import CommonTableByAgGrid from './CommonTableByAgGrid.vue';
export default CommonTableByAgGrid;